<template>
  <div>
    <ObjectiveAdd />
  </div>
</template>

<script>
import ObjectiveAdd from "./ObjectiveAdd.vue";

export default {
  components: {
    ObjectiveAdd,
  },

  data() {
    return {};
  },
};
</script>
